import { createContext } from 'react'

const LoaderContext = createContext({
  isLoading: false,
  showLoader: () => {},
  hideLoader: () => {},
})

export default LoaderContext
